import React from 'react';
import { useTranslation } from 'react-i18next';
import { mockServices } from '../mock/data';
import { Zap, Workflow, ShieldCheck, Battery, Cable, Wrench } from 'lucide-react';

const iconMap = {
  Zap: Zap,
  Workflow: Workflow,
  ShieldCheck: ShieldCheck,
  Battery: Battery,
  Cable: Cable,
  Wrench: Wrench
};

const Services = () => {
  const { t } = useTranslation();

  return (
    <div className="page-services">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">{t('services.title')}</h1>
          <p className="page-subtitle">{t('services.subtitle')}</p>
        </div>
      </section>

      <section className="services-content">
        <div className="container">
          <div className="services-grid">
            {mockServices.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <div key={service.id} className="service-card">
                  <div className="service-icon">
                    <IconComponent size={36} />
                  </div>
                  <h3 className="service-title">
                    {t(`services.${service.key}.title`)}
                  </h3>
                  <p className="service-description">
                    {t(`services.${service.key}.description`)}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="services-image-section">
        <div className="container">
          <div className="services-image-grid">
            <img 
              src="https://customer-assets.emergentagent.com/job_edge-marine-corp/artifacts/oekq9gxw_WhatsApp%20Image%202026-02-05%20at%2019.24.02.jpeg" 
              alt="Electrical Power Distribution Systems"
              className="service-feature-img"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_edge-marine-corp/artifacts/4cziy0ew_WhatsApp%20Image%202026-02-05%20at%2019.24.02%20%284%29.jpeg" 
              alt="Cable Routing and Segregation"
              className="service-feature-img"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
